var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from 'react';
import { classes, st } from './MediaLabel.st.css';
import { MEDIA_LABEL_ICON_DATA_HOOK, MEDIA_LABEL_TEXT_DATA_HOOK, } from './dataHooks';
import { MediaLabelSize, } from './types';
/** An indication over media components, includes a background, text and an icon. can choose a size: small/large and to present text, icon or both  */
var MediaLabel = /** @class */ (function (_super) {
    __extends(MediaLabel, _super);
    function MediaLabel() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MediaLabel.prototype.render = function () {
        var _a = this.props, className = _a.className, text = _a.text, icon = _a.icon, size = _a.size;
        return (React.createElement("div", { className: st(classes.root, { withIcon: !!icon, smallMediaLabel: size === MediaLabelSize.small }, className), dir: "ltr", "aria-hidden": "true", "data-hook": this.props['data-hook'] },
            icon && (React.createElement("span", { className: classes.icon, "data-hook": MEDIA_LABEL_ICON_DATA_HOOK }, icon)),
            text && (React.createElement("span", { className: classes.text, "data-hook": MEDIA_LABEL_TEXT_DATA_HOOK }, text))));
    };
    MediaLabel.displayName = 'MediaLabel';
    MediaLabel.defaultProps = {
        size: 'large',
    };
    return MediaLabel;
}(React.Component));
export { MediaLabel };
//# sourceMappingURL=MediaLabel.js.map